const store = {
    namespaced: true,
    state() {
        return {
            // opened: [],
        }
    },
    getters: {
        // opened: (state) => state.opened
    },
    mutations: {
        // OPEN: (state, name) => state.opened.unshift(name),
    },
    actions: {
        sendSupportMessage: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'post',
                    url: `/api/support/`,
                    data: {
                        name: data.name,
                        email_address: data.email,
                        body: data.message,
                    }
                })
                console.log(data)
            } catch (error) {
                console.dir(error)
            }
        },
    }
}

export default store